import React from 'react';

import {
  STATISTICS_ORDERS as FILTERS_STATISTICS_ORDERS,
} from '../../orders/filters';

import createChartGroup from '../createChartGroup';

import {
  Groups,
  GroupsWrapper,
  GroupsLoading,
} from '../../../components/Statistics';

import {
  filterCompare,
} from '../filters';

const GROUPS = [{
  id: 'average',
  title: 'Average',
  percentage: false,
  views: false,
  charts: [{
    id: 'averageOrderValue',
    label: 'Order',
    title: 'Average order value.',
  }],
}, {
  id: 'total',
  title: 'Total',
  percentage: true,
  charts: [{
    id: 'refundsPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Orders: All / Refunded.',
  }, {
    id: 'refundsPerRevenue',
    label: 'Revenue',
    title: 'Revenue: All / Refunded.',
  }],
}, {
  id: 'shipping',
  title: 'Shipping Methods',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  skipEmpty: true,
  charts: [{
    id: 'shippingPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Orders placed per shipping method.',
  }, {
    id: 'shippingPerRevenue',
    label: 'Revenue',
    title: 'Revenue earned per shipping method.',
  }],
}, {
  id: 'payment',
  title: 'Payment Methods',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  skipEmpty: true,
  charts: [{
    id: 'paymentPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Orders placed per payment method.',
  }, {
    id: 'paymentPerRevenue',
    label: 'Revenue',
    title: 'Revenue earned per payment method.',
  }],
}, {
  id: 'days',
  title: 'Week Days',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'daysPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Orders placed per week day.',
  }, {
    id: 'daysPerRevenue',
    label: 'Revenue',
    title: 'Revenue eardned per week day.',
  }],
}, {
  id: 'hours',
  title: 'Hours',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'hoursPerOrders',
    label: 'Orders',
    precision: 0,
    title: 'Orders placed per hour.',
  }, {
    id: 'hoursPerRevenue',
    label: 'Revenue',
    title: 'Revenue earned per hour.',
  }],
}].map(group => createChartGroup(group));

export default ['PageStatistics', {
  id: 'statistics-orders',
  title: 'Orders',
  label: 'Orders',
  path: '/analytics/orders',
  loadUrl: '/statistics/orders',
  getUseFiltersExtra: () => true,
  redirect: [['redirect.unauthorized']],
  filters: [
    filterCompare,
    ...FILTERS_STATISTICS_ORDERS.map(a => ([a[0], {
      ...a[1],
      // isExtra: false,
      whereSide: 'where',
    }])),
    ...FILTERS_STATISTICS_ORDERS.map(a => ([a[0], {
      ...a[1],
      id: `b.${a[1].id}`,
      // isExtra: false,
      section: 'topCompare',
      whereSide: 'whereB',
      skip: [
        ...(a[1].skip || []),
        props => !['1', '2'].includes(`${props.searchParams.compare}`),
      ],
    }])),
  ],
  renderStats: (props) => {
    if (!props.data && props.loading) {
      return (
        <GroupsWrapper>
          <GroupsLoading />
        </GroupsWrapper>
      );
    }
    if (!props.data || !props.data.data) {
      return <GroupsWrapper />;
    }
    return (
      <GroupsWrapper loading={props.loading}>
        <Groups {...props} groups={GROUPS} />
      </GroupsWrapper>
    );
  },
}];
